// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"968":"41d0b4378ce0ca58","1062":"0abbe697f951563f"}[chunkId] + ".css";
};